import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CategoriesService } from 'src/app/services/categori.service';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  form: FormGroup | any;
  loading = false;
  submitted = false;

  constructor(private rest: CategoriesService) {}

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
    });
  }

  submit() {
    if (!this.form.valid) return;
    this.loading = true;
    this.rest.forgotPassword(this.form.value).subscribe(
      (res: any) => {
        this.loading = false;
        this.submitted = true;
      },
      (err: any) => {
        this.loading = false;
        this.rest.errorToaster(err?.error?.message || 'toast.error_generic');
      }
    );
  }
}
